import { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import { AppDialog } from "../../components/AppDialog";
import { AppDialogHeader } from "../../components/AppDialogHeader";
import { WatchTogetherForm } from "./WatchTogetherForm";
import type { TogetherMediaType } from "../../../types";

// Thin host for WatchTogetherForm.tsx (which owns all the real invite/
// schedule/upcoming/history logic) - used when a video is already open in
// the Lightbox (Lightbox.tsx's "Watch together" action, the only remaining
// caller that sets appState.togetherInviteDialogOpen = true; Home's
// activity card now goes through the dedicated /watch-together page
// instead, see useActivityCards.ts). `filename`/`mediaType` come from
// TogetherRoot.tsx's derivation of the currently-open Lightbox item, so
// they're always real here.
//
// The form is only mounted while `open` is true (rather than always
// rendering and passing `open` down) - remounting on every open is what
// resets its internal state (mode/date/recipient/error) between uses,
// replacing what used to be a manual `[open]`-keyed reset effect inside
// the form itself.
export function TogetherInviteDialog({
  open,
  filename,
  mediaType,
  onClose,
}: {
  open: boolean;
  filename: string | null;
  mediaType: TogetherMediaType;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);

  function handleClose(): void {
    if (busy) return;
    onClose();
  }

  return (
    <AppDialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <AppDialogHeader icon="bi-people-fill" title="Watch Together" onBack={handleClose} disabled={busy} />
      <DialogContent sx={{ pt: 1 }}>
        {open && <WatchTogetherForm filename={filename} mediaType={mediaType} onDone={onClose} onBusyChange={setBusy} />}
      </DialogContent>
    </AppDialog>
  );
}
